import { Body, Heading, Icon, Button } from "@elaniintc/goes-design-system";
import type { PaymentRequest } from "@/queries/payment";

interface PaymentAlertProps {
  status: string;
  paymentData?: PaymentRequest;
}

export const PaymentAlert = ({ status, paymentData }: PaymentAlertProps) => {
  const errorStates = ["REJECTED", "EXPIRED", "FAILED", "CANCELLED"];

  // Alerta para pagos eximidos
  if (status === "EXEMPT") {
    const handleViewDocument = () => {
      if (paymentData?.media?.url) {
        window.open(paymentData.media.url, "_blank", "noopener,noreferrer");
      }
    };

    // Obtener comentarios de exención
    const exemptionComments = paymentData?.exempt_reason;

    return (
      <div className="rounded-xl border border-neutral-quiet bg-neutral-object-accent-silent p-4 w-full">
        <div className="flex gap-3">
          <div className="flex-1 flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center border border-neutral-quiet w-6 h-6 bg-neutral-object-accent rounded-full shrink-0">
                <Icon
                  type="fas"
                  name="circle-info"
                  className="text-body-quiet"
                  size="xs"
                />
              </div>
              <Heading variant="h6" className="text-body-loud">
                El pago no se realizará por el siguiente motivo:
              </Heading>
            </div>
            <Body className="text-body text-sm mt-1 whitespace-pre-line text-justify">
              {exemptionComments ||
                "No se proporcionó un motivo para la exención."}
            </Body>
            {paymentData?.media?.url && (
              <div className="flex flex-col gap-2 items-start">
                <Button variant="ghost" size="xs" onClick={handleViewDocument}>
                  Ver archivo justificante{" "}
                  <Icon type="far" name="arrow-up-right" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (!errorStates.includes(status)) {
    return null;
  }

  const alertContent = {
    REJECTED: {
      title: "Tarjeta rechazada",
      message:
        "La tarjeta introducida ha sido rechazada por la entidad de pagos",
    },
    EXPIRED: {
      title: "Pago expirado",
      message: "El tiempo límite para completar el pago ha expirado",
    },
    FAILED: {
      title: "Pago fallido",
      message: "El pago no pudo ser procesado. Por favor, intente nuevamente",
    },
    CANCELLED: {
      title: "Pago cancelado",
      message: "El pago fue cancelado",
    },
  };

  const content =
    alertContent[status as keyof typeof alertContent] || alertContent.REJECTED;

  return (
    <div className="bg-danger-silent border border-danger-quiet rounded-xl p-4 flex items-center gap-3">
      <Icon type="fas" name="times-circle" className="text-danger" size="lg" />
      <div className="flex-1">
        <Heading variant="h6" className="text-danger mb-1">
          {content.title}
        </Heading>
        <Body className="text-body">{content.message}</Body>
      </div>
    </div>
  );
};
